/* Lightweight first-party analytics tracker.
   Fires once per page view. Uses sessionStorage for a 30-min visitor session.
   Privacy: no cookies, no personal data. Only fires when the user has granted analytics consent. */
import api from "./api";
import { getConsent } from "./consent";

const SESSION_KEY = "mhh_session";
const SESSION_TTL_MS = 30 * 60 * 1000;

function ensureSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (raw) {
      const { id, ts } = JSON.parse(raw);
      if (id && ts && Date.now() - ts < SESSION_TTL_MS) {
        sessionStorage.setItem(SESSION_KEY, JSON.stringify({ id, ts: Date.now() }));
        return id;
      }
    }
  } catch (err) {
    /* ignore — sessionStorage may be unavailable (private browsing) */
  }
  const id = (crypto?.randomUUID?.() || (Date.now().toString(36) + Math.random().toString(36).slice(2, 10))).replace(/-/g, "").slice(0, 24);
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify({ id, ts: Date.now() }));
  } catch (err) {
    /* ignore */
  }
  return id;
}

export function trackPageView(path) {
  // Respect the user's cookie consent — no ping until analytics is opted-in
  const prefs = getConsent();
  if (!prefs || !prefs.analytics) return;
  try {
    const session_id = ensureSession();
    const ref = document.referrer && !document.referrer.includes(window.location.host) ? document.referrer : "";
    api.post("/track", {
      path: path || window.location.pathname,
      referrer: ref,
      session_id,
      title: document.title?.slice(0, 200) || "",
    }).catch(() => { /* fire-and-forget */ });

    // Also send to GA4 if it's loaded
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path || window.location.pathname,
        page_title: document.title,
      });
    }
  } catch (err) {
    /* fire-and-forget */
  }
}

